<script setup lang="ts">
    import { computed } from 'vue';
    import { useForm } from '@inertiajs/vue3';
    import { UserCompany } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import UserCompanyForm from './UserCompanyForm.vue';
    import QueryKey from '@/enums/QueryKey';

    const props = defineProps<{
        userCompany: UserCompany;
        open?: boolean;
        hideTrigger?: boolean;
        afterSuccess?: () => void;
    }>();

    const emit = defineEmits<{
        finish: [];
        success: [];
        'update:open': [value: boolean];
    }>();

    const handleSuccess = () => {
        emit('success');
    };

    const dialogFormBindings = computed(() => {
        if (!props.hideTrigger) {
            return {};
        }

        return {
            open: props.open,
            hideTrigger: true,
        };
    });

    const handleUpdateOpen = (value: boolean) => {
        if (props.hideTrigger) {
            emit('update:open', value);
        }
    };

    const form = useForm({
        company_id: props.userCompany.id,
        user_ids: [
            ...props.userCompany.employee_group_ids,
            ...props.userCompany.employee_users.map((user) => user.id.toString()),
        ],
    });
</script>

<template>
    <DialogForm
        v-bind="dialogFormBindings"
        type="update"
        :form="form"
        :route="route('v2.user-companies.update')"
        :query-key="[QueryKey.USER_COMPANIES]"
        title="companies.user_companies_edit_title"
        success-message="companies.user_companies_edit_success"
        error-message="companies.user_companies_edit_error"
        :after-success="afterSuccess"
        @success="handleSuccess"
        @finish="$emit('finish')"
        @update:open="handleUpdateOpen"
    >
        <UserCompanyForm :form="form" />
    </DialogForm>
</template>
